//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: "stuinfo",
        props:{
            stuinfo:{
                type: Object,
                default: () => ({})
            }
        }
    }



// WEBPACK FOOTER //
// ./src/components/common/stuinfo.vue